<mat-form-field appearance="outline" class="phone-field" required>
  <mat-label>Phone Number</mat-label>
  <mat-select
    id="riderPhoneNumber-select-phoneNumberSelection"
    [value]="currentPhoneNumberSelection"
    [disabled]="riderContactProfiles.length === 1"
    (selectionChange)="handlePhoneNumberSelected($event)"
    data-private
  >
    <mat-option
      *ngFor="let riderContactProfile of riderContactProfiles"
      id="riderPhoneNumber-option-{{ riderContactProfile.phoneNumber }}"
      [value]="riderContactProfile.phoneNumber"
    >
      {{ formatPhoneNumber(riderContactProfile.phoneNumber, riderContactProfile.organizationCode) }}
    </mat-option>
  </mat-select>
</mat-form-field>
<p id="riderPhoneNumber-text-phoneNumberMessage" class="form-field-subtitle">Phone number updates must be made in the rider’s profile.</p>
